import gql from 'graphql-tag';

export default gql`
  fragment TweetMetadata on TweetMetadata {
    id_str
    created_at
    text
    favorite_count
    retweet_count
    user {
      name
      screen_name
      profile_image_url_https
      verified
    }
    hashtags {
      text
    }
    urls {
      display_url
      expanded_url
    }
    user_mentions {
      id_str
      name
      screen_name
    }
    media {
      media_url_https
      type
    }
  }
`;
